import createIcon from '../../createIcon';

/**
 * @component @name Crop32
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNkg1QzMuOSA2IDMgNi45IDMgOFYxNkMzIDE3LjEgMy45IDE4IDUgMThIMTlDMjAuMSAxOCAyMSAxNy4xIDIxIDE2VjhDMjEgNi45IDIwLjEgNiAxOSA2Wk0xOSAxNkg1VjhIMTlWMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Crop32 = createIcon('Crop32', [
  [
    'path',
    {
      d: 'M19 6H5C3.9 6 3 6.9 3 8V16C3 17.1 3.9 18 5 18H19C20.1 18 21 17.1 21 16V8C21 6.9 20.1 6 19 6ZM19 16H5V8H19V16Z',
      key: 'cip8oo',
    },
  ],
]);

export default Crop32;
